import { render, staticRenderFns } from "./CompleteProfileBanner.vue?vue&type=template&id=785a2823&scoped=true&"
import script from "./CompleteProfileBanner.vue?vue&type=script&lang=js&"
export * from "./CompleteProfileBanner.vue?vue&type=script&lang=js&"
import style0 from "./CompleteProfileBanner.vue?vue&type=style&index=0&id=785a2823&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785a2823",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/CompleteProfileBanner.vue
// module id = null
// module chunks = 